import classnames from 'classnames';
import React from 'react';
import { FilterHidingContextButton } from '../controls/FilterBar';
import PanelButtons from '../controls/PanelButtons';
import useHelpNoteTitle from './Translations/useHelpNoteTitle';
import styles from './FormTitle.scss';
const FormTitle = ({ children, title = 'Form', tooltipTitle = '', className = '', isOverflownTextHidden = true, }) => {
    const resolvedTooltipTitle = useHelpNoteTitle(title, tooltipTitle);
    return children ? (children(title, className)) : (<h5 className={classnames({ [styles.formTitle]: isOverflownTextHidden }, className)} title={isOverflownTextHidden ? resolvedTooltipTitle || title : undefined}>
      {title}
      <PanelButtons>
        <FilterHidingContextButton />
      </PanelButtons>
    </h5>);
};
export default FormTitle;
